<template>
  <div class="CartNav relative inline-flex items-center leading-gr-7">
    <jet-dropdown
      @on-toggle="onToggle"
      align="right"
      width="w-[90vw] sm:max-w-md"
      content-classes="py-gr-6 bg-white dark:bg-primary-darker translate-x-gr-7 -mr-gr-3 sm:translate-x-0 sm:-mr-gr-4"
      :force-close="forceClose"
    >
      <template #trigger>
        <button class="px-gr-3 relative" ref="toggleBtn">
          <i class="fas fa-fw fa-shopping-bag"></i>
          <template v-if="showMenuDot">
            <div class="absolute top-gr-1 left-0 w-gr-4 h-gr-4 rounded-full bg-red-500"></div>
          </template>
        </button>
      </template>
      <template #content>
        <button
          @click.prevent="forceClose = true"
          class="text-gray-300 hover:text-blue-800 dark:text-gray-600 dark:hover:text-blue-400 px-gr-5 h-gr-double-6 flex items-center justify-center absolute top-0 right-0"
        >
          <i class="fas fa-times fa-fw"></i>
        </button>
        <div class="flex justify-center items-center h-gr-double-7" :class="{ hidden: !isLoading }">
          <i class="fad fa-spinner-third fa-spin fa-2x"></i>
        </div>
        <div v-if="!isLoading" class="px-gr-5 sm:px-gr-6">
          <!-- For Now -->
          <div v-if="itemsForNow.length" class="mb-gr-7">
            <div class="text-center mb-gr-6">
              <div class="text-2xl font-bold">Your Bag</div>
              <!-- <div>These are currently <strong>on sale!</strong></div> -->
            </div>
            <cart-item v-for="item in itemsForNow" :promo="item.promo" show-remove-btn />
            <div class="mt-gr-6 flex justify-end">
              <button
                :disabled="isCheckoutLoading"
                class="button button-primary"
                @click.prevent.stop="onCheckoutNow"
              >
                Checkout Now
                <span :hidden="!isCheckoutLoading"
                  ><i class="ml-gr-3 fa-fw fad fa-spinner-third fa-spin"></i
                ></span>
                <span :hidden="isCheckoutLoading"
                  ><i class="ml-gr-3 fa-fw fal fa-arrow-right"></i
                ></span>
              </button>
            </div>
          </div>

          <!-- For Later -->
          <div v-if="itemsForLater.length" class="mb-gr-7">
            <div class="text-center mb-gr-6">
              <div class="text-2xl font-bold">Saved for Later</div>
              <!-- <div>These are currently <strong>on sale!</strong></div> -->
            </div>
            <cart-item v-for="item in itemsForLater" :promo="item.promo" show-add-btn />
          </div>

          <!-- On Sale -->
          <div v-if="onSaleItems.length">
            <div class="text-center mb-gr-6">
              <div class="text-2xl font-bold">
                {{ itemsForNow.length ? 'More Deals' : 'No Items Added' }}
              </div>
              <div>These are currently <strong>on sale!</strong></div>
            </div>
            <cart-item v-for="promo in onSaleItems" :promo="promo" show-view-btn />
            <div
              class="text-center mt-gr-6"
              v-if="promosOnSale.current_page !== promosOnSale.last_page"
            >
              <subdomain-link root :href="route('browse', { filterBy: 'onSale' })" class="link">
                <span class="underline">View More On Sale</span
                ><i class="fal fa-arrow-right ml-gr-3"></i>
              </subdomain-link>
            </div>
          </div>

          <!-- Loading -->
          <div
            v-else-if="!isLoading && !itemsForNow.length && !itemsForLater.length"
            class="text-center"
          >
            <div class="text-2xl font-bold">No Items Added</div>
            <div>
              Can't stand the silence?
              <subdomain-link root :href="route('browse')" class="link">
                <span class="underline">Browse All Titles</span
                ><i class="ml-gr-3 fal fa-arrow-right"></i>
              </subdomain-link>
            </div>
          </div>
        </div>
      </template>
    </jet-dropdown>
  </div>
</template>

<script>
  import JetDropdown from '@/Jetstream/Dropdown';
  import CartItem from '@/Components/CartItem';
  import { CartBus } from '@/Utils/bus';

  export default {
    name: 'CartNav',

    props: {
      itemsForNow: {
        type: Array,
        default: () => [],
      },
      itemsForLater: {
        type: Array,
        default: () => [],
      },
      promosOnSale: {
        type: Object,
        default: () => ({}),
      },
    },

    components: {
      JetDropdown,
      CartItem,
    },

    data() {
      return {
        isLoading: false,
        forceClose: false,
        isCheckoutLoading: false,
        checkoutForm: this.$inertia.form({
          items: this.itemsForNowIds,
        }),
      };
    },

    computed: {
      showMenuDot() {
        return this.itemsForNow.length;
      },

      onSaleItems() {
        return this.promosOnSale?.data || [];
      },

      itemsForNowIds() {
        return this.itemsForNow.reduce((arr, cur) => {
          arr.push(cur.id);
          return arr;
        }, []);
      },
    },

    watch: {
      itemsForNowIds(newVal, oldVal) {
        this.checkoutForm.items = this.itemsForNowIds;
      },
    },

    created() {
      // setTimeout(this.loadItems.bind(this), 5000);
    },

    mounted() {
      CartBus.$on('toggle', () => {
        this.$refs['toggleBtn']?.click();
      });
    },

    beforeUnmount() {
      CartBus.$off('toggle', () => {});
    },

    methods: {
      onCheckoutNow() {
        this.isCheckoutLoading = true;
        this.checkoutForm.post(route('cart.checkout'), {
          preserveState: true,
          preserveScroll: true,
          onSuccess: () => {
            this.isCheckoutLoading = false;
          },
          onError: (error) => {
            this.isCheckoutLoading = false;
            console.log('%c error -->', 'color:#F80', error);
          },
        });
      },

      onToggle(open) {
        if (open && this.isLoading === false) {
          this.loadItems();
        }
      },

      loadItems() {
        this.isLoading = true;

        if (this.$inertia.activeVisit?.completed === false) {
          return requestAnimationFrame(this.loadItems.bind(this));
        }

        this.$inertia.reload({
          only: ['itemsForNow', 'itemsForLater'],
          onSuccess: () => {
            this.isLoading = false;
            if (!this.itemsForNow.length || !this.itemsForLater.length) {
              this.getOnSale();
            }
          },
        });
      },

      getOnSale() {
        this.isLoading = true;

        if (this.$inertia.activeVisit?.completed === false) {
          return requestAnimationFrame(this.getOnSale.bind(this));
        }

        this.$inertia.reload({
          only: ['promosOnSale'],
          onSuccess: () => {
            this.isLoading = false;
          },
        });
      },
    },
  };
</script>

<!-- <style lang="scss" src="./CartNav.scss" scoped></style> -->
